import '@walmart-dataventures/shared-components/dist/esm/index.css';
import '@walmart-dataventures/integrated-components/dist/style.css';
import React, { useEffect, useState } from 'react';
import { theme } from './theme/theme';
import { ThemeProvider, StylesProvider } from '@material-ui/core/styles';
import CPRoutes from './routes';
import { performAuthorization } from './client/authservice';
import { UserPortalContext } from './context/appcontext';
import analytics from './helper/analytics';
import { Announcement } from '@walmart-dataventures/integrated-components';
import { setPersona } from './redux/actions/appGuideActions';
import { useDispatch } from 'react-redux';
import { LuminateLoader as ProgressLoader } from '@walmart-dataventures/shared-components';

// AG-Grid
import { LicenseManager } from 'ag-grid-enterprise';
import 'ag-grid-enterprise/styles/ag-grid.css';
import 'ag-grid-enterprise/styles/ag-theme-alpine.css';
import './components/DVTable/style.css';
import client from './apollo/index.js';
import { getCustomAttributesQuery } from './apollo/queryBuilder/customAtrributesQueryBuilder';
import { apolloHeaders } from './apollo/utils';
import { gql } from '@apollo/client';
import { setCustomAtrributeNames } from './redux/actions/tableActions.js';

LicenseManager.setLicenseKey(
	'Using_this_AG_Grid_Enterprise_key_( AG-049209 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Walmart Inc. )_is_granted_a_( Multiple Applications )_Developer_License_for_( 4 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_AG_Grid_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 13 November 2024 )____[v2]_MTczMTQ1NjAwMDAwMA==1beafb88faad7992e95a6219f756fefb'
);
function App() {
	const [userDetails, setUserDetails] = useState(undefined);
	const [appLoading, setAppLoading] = useState(true);
	const dispatch = useDispatch();

	const defineAdobeAnalytics = () => {
		analytics.setBase();
		analytics?.loadContent(document.getElementsByTagName('head')[0]);
		analytics?.loadAdobeScript();
	};

	const customAttributesPayload = gql`
		${getCustomAttributesQuery()}
	`;

	useEffect(() => {
		(async () => {
			try {
				defineAdobeAnalytics();
				await performAuthorization(setAppLoading, setUserDetails);
			} catch (error) {
				console.error(error);
			}
		})();
		sessionStorage.removeItem('view');
		sessionStorage.setItem('firstTimeUser', true);
		client
			.query({
				query: customAttributesPayload,
				fetchPolicy: 'cache-first',
				context: {
					headers: apolloHeaders('customAttributeNames'),
				},
			})
			.then((res) => {
				dispatch(
					setCustomAtrributeNames(res?.data?.customAttributeNames?.edges)
				);
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	useEffect(() => {
		const isCatman = userDetails?.persona_access_codes?.includes('2000');
		dispatch(setPersona(isCatman));
	}, [userDetails]);

	return (
		<ThemeProvider theme={theme}>
					{appLoading ? (
						<ProgressLoader showImage />
					) : (
						<UserPortalContext.Provider value={userDetails}>
							<StylesProvider injectFirst>
								<Announcement locationBased={true} />
								<CPRoutes />
							</StylesProvider>
						</UserPortalContext.Provider>
					)}
				</ThemeProvider>
	);
}

export default App;
